import {connect} from 'react-redux';

import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getCrmSyncs} from '../../../../store/data/crmSync/crmSyncsSelectors';
import {getUsersSyncJobs} from '../../../../store/data/jobs/jobsSelectors';
import {CrmSyncBanners} from './crmSyncBanners';

/*
 * Props.
 */

interface CrmSyncBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CrmSyncBannersContainerProps>()(() => ({
  // Only display banners for sync jobs the user initiated.
  syncJobs: getUsersSyncJobs,
  crmSyncs: getCrmSyncs,
}));

export const CrmSyncBannersContainer = connect(mapStateToProps)(CrmSyncBanners);
